import { useEffect, useState } from 'react';
import axios from 'axios';

export const SOCIAL_PLATFORMS = [
  { id: 'instagram', label: 'Instagram', placeholder: 'https://www.instagram.com/deenlit/' },
  { id: 'facebook', label: 'Facebook', placeholder: 'https://www.facebook.com/deenlit' },
  { id: 'x', label: 'X', placeholder: 'https://x.com/deenlit' },
  { id: 'youtube', label: 'YouTube', placeholder: 'https://www.youtube.com/@deenlit' },
  { id: 'tiktok', label: 'TikTok', placeholder: 'https://www.tiktok.com/@deenlit' },
];

export const emptySocialLinks = () => Object.fromEntries(SOCIAL_PLATFORMS.map(({ id }) => [id, '']));
export const emptySocialEnabled = () => Object.fromEntries(SOCIAL_PLATFORMS.map(({ id }) => [id, false]));

const PLATFORM_HOSTS = {
  instagram: ['instagram.com', 'www.instagram.com'],
  facebook: ['facebook.com', 'www.facebook.com', 'm.facebook.com'],
  x: ['x.com', 'www.x.com', 'twitter.com', 'www.twitter.com'],
  youtube: ['youtube.com', 'www.youtube.com', 'm.youtube.com'],
  tiktok: ['tiktok.com', 'www.tiktok.com'],
};

export function normalizeSocialLink(id, value) {
  const platform = SOCIAL_PLATFORMS.find(item => item.id === id);
  if (!platform || typeof value !== 'string' || value.length > 300) return { error: `${platform?.label || 'Social'} needs a link shorter than 300 characters.` };
  const trimmed = value.trim();
  if (!trimmed) return { href: '' };
  let url;
  try { url = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`); }
  catch { return { error: `${platform.label} needs an account link, such as ${platform.placeholder}.` }; }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.port) return { error: `${platform.label} needs an HTTPS account link.` };
  if (!PLATFORM_HOSTS[id].includes(url.hostname.toLowerCase())) return { error: `${platform.label} must link to ${PLATFORM_HOSTS[id][0]}.` };
  if (!url.pathname || url.pathname === '/') return { error: `${platform.label} needs your account or channel name after the website address.` };
  url.protocol = 'https:';
  return { href: url.href };
}

export function useSocialLinks() {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const { data } = await axios.get('/api/site/socials');
        if (active) setLinks(SOCIAL_PLATFORMS.filter(({ id }) => data?.links?.[id]).map(platform => ({ ...platform, href: data.links[platform.id] })));
      } catch { if (active) setLinks([]); }
    };
    load();
    const refreshWhenVisible = () => { if (!document.hidden) load(); };
    window.addEventListener('deenlit-social-links-updated', load);
    window.addEventListener('focus', load);
    document.addEventListener('visibilitychange', refreshWhenVisible);
    return () => {
      active = false;
      window.removeEventListener('deenlit-social-links-updated', load);
      window.removeEventListener('focus', load);
      document.removeEventListener('visibilitychange', refreshWhenVisible);
    };
  }, []);
  return links;
}
